var exports = {
  "Q": "xfb577c5e--8cc5d3--text",
};

module.exports = exports;
